import { FC } from "react";
import styled, { css } from "styled-components";
import useScrollerAdjuster from "lib/hooks/gonzo/useScrollerAdjuster";

const KeyVisualScroll: FC = () => {
  const [slideUpper1, slideUpper2, slideLower1, slideLower2] = useScrollerAdjuster();
  return (
    <Root>
      <ScrollerUpper>
        <AnimeKeyVisualUpper1 ref={slideUpper1} src="/image/lp/gonzo/mv/mv_image.png" />
        <AnimeKeyVisualUpper2 ref={slideUpper2} src="/image/lp/gonzo/mv/mv_image.png" />
      </ScrollerUpper>
      <LogoArea>
        <Logo src="/image/lp/gonzo/mv/mv_logo.png" alt="GONZO 30th Anniversary" />
      </LogoArea>
      <ScrollerLower>
        <AnimeKeyVisualLower1 ref={slideLower1} src="/image/lp/gonzo/mv/mv_image.png" />
        <AnimeKeyVisualLower2 ref={slideLower2} src="/image/lp/gonzo/mv/mv_image.png" />
      </ScrollerLower>
    </Root>
  );
};
export default KeyVisualScroll;

const Root = styled.section`
  @media screen and (max-width: 960px) {
    margin-bottom: 120px;
  }
  @media screen and (min-width: 961px) {
    margin-bottom: 200px;
  }
`;

const LogoArea = styled.div`
  position: relative;
  z-index: 2;
  @media screen and (max-width: 960px) {
    width: 80%;
    margin: -10px auto;
    min-width: 340px;
  }
  @media screen and (min-width: 961px) {
    width: 70%;
    margin: -30px auto;
    max-width: 1200px;
  }
`;
const Logo = styled.img`
  width: 100%;
`;

const scroller = css`
  position: relative;
  overflow: hidden;
  z-index: 1;
  @media screen and (max-width: 960px) {
    height: 27vw;
  }
  @media screen and (min-width: 961px) {
    height: 13.5vw;
  }
`;
const ScrollerUpper = styled.div`
  ${scroller};
`;
const ScrollerLower = styled.div`
  ${scroller};
`;
const animeKeyVisual = css`
  position: absolute;
  top: 0;
  @media screen and (max-width: 960px) {
    padding-right: 0.6%;
    width: 300%;
  }
  @media screen and (min-width: 961px) {
    padding-right: 0.5%;
    width: 150%;
  }
  @keyframes upperSlide {
    100% {
      transform: translateX(-200%);
    }
  }
  @keyframes lowerSlide {
    100% {
      transform: translateX(200%);
    }
  }
`;
const AnimeKeyVisualUpper1 = styled.img`
  ${animeKeyVisual};
  left: 100%;
  animation: upperSlide 90s linear infinite -45s;
`;
const AnimeKeyVisualUpper2 = styled.img`
  ${animeKeyVisual};
  left: 100%;
  animation: upperSlide 90s linear infinite;
`;

const AnimeKeyVisualLower1 = styled.img`
  ${animeKeyVisual};
  right: 100%;
  animation: lowerSlide 90s linear infinite -45s;
`;
const AnimeKeyVisualLower2 = styled.img`
  ${animeKeyVisual};
  right: 100%;
  animation: lowerSlide 90s linear infinite;
`;
